import { CENTRA_MARKET_CODE, CentraMarketCode } from "@/data/supported-markets"

type UppercaseCountryCode = "JP" | "GB" | "US" | "AU"

export type MarketCodeToDefaultCountryMap = Map<CentraMarketCode, UppercaseCountryCode>

const marketCodeToDefaultCountry: MarketCodeToDefaultCountryMap = new Map<
    CentraMarketCode,
    UppercaseCountryCode
>([
    [CENTRA_MARKET_CODE.Jp, "JP"],
    [CENTRA_MARKET_CODE.Eu, "GB"],
    [CENTRA_MARKET_CODE.Na, "US"],
    [CENTRA_MARKET_CODE.Apac, "AU"]
])

export default marketCodeToDefaultCountry
